<!--
     Note:  the HTML in this file was taken from role-membership.dialog.html, part of a component
            that will be retired once we switch over entirely to the new permissions model.
-->
<!--<h4 class="h4">{{this.Title}}</h4>-->

<div class="members-table-wrapper">
    <ng-container *ngIf="this.Members != null">
        <table #roleMemberTable mat-table [dataSource]="this.Members" class="members-table">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    Select
                </th>
                <td mat-cell *matCellDef="let user">
                    <mat-checkbox [(ngModel)]="user.selected" [disabled]="false" (change)="this.Dirty=true"></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let user"> {{user.member}} </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let user">
                    <button mat-icon-button
                            type="button"
                            (click)="deleteMember($event, user)"
                            (keyup.enter)="deleteMember($event, user)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="this.DisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: this.DisplayedColumns;"></tr>
        </table>
    </ng-container>
</div>

<!--
<div [ngClass]="isFolderLevel() ? '' : 'delete-all-btn'">
    <button mat-flat-button color="warn" (click)="deleteAllMembers()">Delete All</button>
</div>
-->

<div class="add-member-form">
    <!-- reactive form may seem like overkill, but it makes auto complete easy -->
    <form matForm [formGroup]="this.AddMemberForm" class="addMemberForm">
        <div class="add-member-control-wrapper">
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="add-member-control">
                <mat-label>Add Member or Group</mat-label>
                <input matInput id="add-role-member-input" formControlName="user" [matAutocomplete]="addMemberAutoComplete" cdkFocusInitial>
                <span matSuffix *ngIf="this.ShowLoadingIndicator"><mat-spinner [diameter]="25"></mat-spinner></span>
                <mat-autocomplete #addMemberAutoComplete [panelWidth]="750" [displayWith]="this.DisplayUserName">
                    <mat-option *ngFor="let pi of this.PickerItems | async" [value]="pi">
                        <span title="{{pi.fullDisplay}}">{{pi.fullDisplay}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <button mat-flat-button matSuffix
                    class="add-member-btn theme-primary-btn"
                    color="primary"
                    [disabled]="!this.AddMemberForm.dirty"
                    (click)="this.addMember()">
                Add
            </button>
        </div>
    </form>
</div>
